export default "__VITE_ASSET__DJ3pA90M__"